import styled from 'styled-components';
import { DropdownIconMixin } from '../../mixins/components/DropdownIconMixin';
export var StyledDropdownIcon = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledDropdownIcon",
  componentId: "c11n-8-111-1__sc-rynrb-0"
})(["", ""], DropdownIconMixin);